import { ECalendarName } from "motw_core/Calendar/ECalendarName";
import { GetEnumNames } from "motw_core/Utils/EnumUtils";
import * as React from "react";
import { FormSelect } from "source/app/presentation/Shared/Form/Select/FormSelect";
import { ICalendarEventEditorState } from "./ICalendarEventEditorState";

export function SelectCalendarForEvent({
    state,
    setState,
}: {
    state: ICalendarEventEditorState;
    setState: React.Dispatch<React.SetStateAction<ICalendarEventEditorState>>;
}) {
    if (state.calendarEvent.isRepeating) {
        return null;
    }

    const calendarNames = GetEnumNames(ECalendarName).filter(
        (calendarName) => calendarName != ECalendarName[ECalendarName.Free]
    );

    return (
        <div style={{ marginTop: `10px` }}>
            <FormSelect
                id="calendarEvent_calendarName"
                label="calendar"
                value={state.calendarEvent.calendar}
                suggestions={calendarNames}
                onChange={(event) =>
                    setState({
                        ...state,
                        calendarEvent: {
                            ...state.calendarEvent,
                            calendar: event.target.value,
                        },
                    })
                }
                width="165px"
            />
        </div>
    );
}
